import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import {
  FILTER_CREATED,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_DOMAINS,
  FILTER_PLATFORMS,
  FILTER_TAGS,
} from 'scenes/Gallery/ConversionPages/constants';

import * as Filters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_CREATED,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_DOMAINS,
  FILTER_PLATFORMS,
  FILTER_TAGS,
];

const PrimaryFilters = () => {
  return (
    <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
      <Filters.Created withClear={true} />
      <Filters.Applications withClear={true} />
      <Filters.Networks withClear={true} />
      <Filters.Platforms withClear={true} />
      <Filters.Domains withClear={true} />
      <Filters.Locales withClear={true} />
      <Filters.Flows withClear={true} />
      <Filters.Tags withClear={true} />
      <Filters.UsedInAds withClear={true} />
      <Filters.IsNew withClear={true} />
    </PrimaryFiltersProvider>
  );
};

export default PrimaryFilters;
